import React from 'react'

import { cn } from '@/lib'

import { Text } from '../ui/text'
import { TooltipInfo } from '../ui/tooltip-v2'

interface InfoRowProps {
  icon: React.ReactNode
  label: React.ReactNode
  underline?: boolean
  children?: React.ReactNode // right part
  className?: string
  tooltipContent?: React.ReactNode
}

export const InfoRow: React.FC<InfoRowProps> = ({
  icon,
  label,
  underline = false,
  children,
  className,
  tooltipContent,
}) => {
  return (
    <div className='flex items-center justify-between w-full text-size-14'>
      <div className={cn('flex items-center text-white-48 gap-2', className)}>
        {icon}
        <span
          style={{
            textDecorationSkipInk: 'none',
            textDecorationThickness: 'auto',
          }}
          className={cn({ 'underline decoration-dotted underline-offset-[3.5px]': underline })}
        >
          {tooltipContent ? (
            <TooltipInfo
              content={tooltipContent}
              icon={
                <Text
                  className='text-white-48 underline decoration-dotted underline-offset-[3.5px]'
                  style={{
                    textDecorationThickness: '0.05rem',
                  }}
                >
                  {label}
                </Text>
              }
            />
          ) : (
            label
          )}
        </span>
      </div>
      <div
        className={cn({
          'text-white-48': !children,
        })}
      >
        {children ?? '_'}
      </div>
    </div>
  )
}
